module.exports = __webpack_public_path__ + "static/media/VQP_logo.8d1b436d.png";